import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer class="footer">
    <div class="footer-text">
        <p>Copyright & Copy 2024 by Sadhan | All Rights Reserved.</p>
    </div>
    <div class="footer-iconTop">
        <a href="#home"><i class='bx bx-up-arrow-alt'></i></a>
    </div>
</footer>
  )
}

export default Footer